"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'step.shared.yes': 'Sì',
    'step.shared.no': 'No',
};
